module.exports = __webpack_public_path__ + "img/mars.be5030ca.webp";